import React from 'react';
import styled from 'styled-components';
import { Container } from '@mui/material';
import SiteHeader from '../Header';

const AuthHeaderLayout = () => {
  return (
    <Header>
      <SiteHeader />
    </Header>
  );
};

const Header = styled(Container)``;

export default AuthHeaderLayout;
